import { useContext } from "react";
import { Box, Grid } from "@mui/material";
import styles from "./styles.module.css";
import { HeaderRupin, InnerWrapper, MainContainer } from "../../common";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { NewNotFoundIcon, NonIdealInvoice } from "../../../assets/icons/icon";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";

const NotFound = () => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { setPinVerified } = useAuthContext();

  return (
    <MainContainer fluid className={`quickSalePage ${styles.offlineContainer}`}>
      <Grid container>
        <Grid item md={12}>
          <InnerWrapper
            className={`innerWrapper newInnerWrapper ${styles.offlineWrapper}`}
          >
            <Box className={styles.header}>
              <HeaderRupin />
            </Box>

            <NonIdealNew
              title={I18n.page_not_found}
              subtitle={I18n.the_page_you_are_looking_for_may_be_moved_or_deleted}
              button1Title={I18n.go_to_home}
              onButton1Click={() => {
                setPinVerified(true);
                navigate("/BusinessOverview");
              }}
              buttonOneId={"not_found_go_back"}
              customClassName={styles.nonIdealContainer}
              mainIcon={<NewNotFoundIcon />}
            />
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default NotFound;
